import { computed, toValue } from "vue";
import { toBoolean } from "#ce/utils/props";

/** Selected chips are available only for an opted-in multiple picker. */
export function useSelectedTagsMode(props, multiple = () => props.multiple) {
  return computed(() => toBoolean(toValue(multiple)) && toBoolean(props.selectedTags));
}
